import(/* webpackMode: "eager" */ "/app/src/app/wedding-venues/[slug]/layout.tsx");
